import { Injectable } from "@angular/core";
import { BackendService } from "./backend";
import { CheckRightsCall } from "./backend/user.call";
import { Observable } from "rxjs";

@Injectable()
export class UserService {
    public constructor(private readonly backendService: BackendService) {}

    public checkUserRights(): Observable<boolean> {
        const call = new CheckRightsCall();
        return this.backendService.executeCall(call);
    }
}